module.exports = __webpack_public_path__ + "img/header-diamondJewelryPlatinum.733c147.webp";